import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { FormularioInscripcionComponent } from './formulario-inscripcion/formulario-inscripcion.component';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { ExitoComponent } from './exito/exito.component';
import { ErrorComponent } from './error/error.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { ModalPagoComponent } from './modal-pago/modal-pago.component';

@NgModule({
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule
  ],
  declarations: [
    AppComponent,
    FormularioInscripcionComponent,
    ExitoComponent,
    ErrorComponent,
    SpinnerComponent,
    ModalPagoComponent,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
